"use client";

import { useEllimae } from "@/store/useEllimae";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";

const ENV = process.env.NEXT_PUBLIC_NODE_ENV || "development";

export const PostHogSetup = () => {
  const posthog = usePostHog();
  const { originResponse: origin, initialized: ellimaeInitialized } =
    useEllimae((state) => state);

  useEffect(() => {
    if (posthog.__loaded) {
      if (ellimaeInitialized && origin) {
        const { clientId, encompassLoanId } = origin;
        posthog.identify(clientId, {
          loanId: encompassLoanId,
          clientId,
          environment: ENV,
        });
      } else {
        posthog.identify("localhost-outside-encompass", {
          environment: ENV,
        });
      }
    }
  }, [origin, ellimaeInitialized, posthog]);

  return null;
};
